<div class="main_content">
  <app-breadcrumb></app-breadcrumb>
  <div #page_section class="page_main_sec">
    <div class="OpenSearch_main_sec">
      <!-- title bar section Start-->
      <div class="container-fluid">
        <!-- <div class="post-nav-wrap">
          <div class="title-wrap">
            <p class="title">Work Item Type Change</p>
          </div>
          <ul class="nav top-actions">
            <li>
              <a [routerLink]="['/home']">
                <i class="material-icons theme-text-color">home</i>
              </a>
            </li>
          </ul>
        </div> -->
      </div>
      <!-- title bar section  End-->
    </div>

    <!-- advance Search section Start-->
    <div class="tab-content">

      <!-- Table View -->
      <div class="table_card_sec mb_0">
        <div class="table scroll_table">
          <div class="row advance-search-wrp">
            <!-- <div class="bx-sub-title">Filter Option</div>             -->
            <div class="col-lg-3">
              <!-- <app-dropdown-multiselect #ddlDocselect [lstDropdownOption]="docTypeList" [labelText]="'Work Item Type'"
                [allSelected]="true">
              </app-dropdown-multiselect> -->
              <mat-form-field appearance="legacy" [style.width.%]="100">
                <mat-label for="Work_item_type">Work Item Type
                  <span class="field-mandatory">*</span>
                </mat-label>
                <mat-select [(ngModel)]="selectedDocumentType" id="Work_item_type"
                  (selectionChange)="onSelectDocumentType($event.value)" (click)="searchText_DocumentType.focus()"
                  (focus)="searchText_DocumentType.focus()" (closed)="searchText_DocumentType.value=''">
                  <input type="search" (keydown)="$event.stopPropagation()" #searchText_DocumentType autocomplete="off"
                    class="mat-select-search" placeholder="Select User">
                  <mat-option [value]="option.value"
                    *ngFor="let option of docTypeList| listFilter:{'text':searchText_DocumentType.value}">
                    {{option.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
            <div class="col-lg-3">
              <mat-form-field [style.width.%]="100">
                <mat-label for="txtURN">URN </mat-label>
                <input matInput id="txtURN" [(ngModel)]="strURN" placeholder="URN" >

              </mat-form-field>
            </div>
            <div class="col-lg-3">
              <mat-form-field appearance="legacy" [style.width.%]="100">
                <mat-label for="txtRange">Record Range<span class="field-mandatory">*</span> </mat-label>
                <input matInput id="txtRange" [(ngModel)]="strRange" placeholder="1-9999999" >

              </mat-form-field>
            </div>
            <div class="col-lg-3">
              <mat-form-field [style.width.%]="100">
                <mat-label for="work_item_creation_date">Work Item Creation Date Range</mat-label>
                <mat-date-range-input [rangePicker]="workitempicker" id="work_item_creation_date"
                  [formGroup]="workItemCreationDateRange">
                  <input matStartDate formControlName="work_item_start_date" #workitemstartdate placeholder="Start Date"
                    [max]="maxDate" (dateChange)="onWorkItemCreationDateChanges()">
                  <input matEndDate formControlName="work_item_end_date" #workitemendDate placeholder="End Date"
                    [max]="maxDate" (dateChange)="onWorkItemCreationDateChanges()">
                </mat-date-range-input>
                <button *ngIf="isWorkItemDateRangeHasValue" mat-button matSuffix mat-icon-button
                  (click)="resetWorkItemCreationDateRange()">
                  <mat-icon>clear</mat-icon>
                </button>
                <mat-datepicker-toggle matSuffix [for]="workitempicker"></mat-datepicker-toggle>
                <mat-date-range-picker #workitempicker></mat-date-range-picker>
              </mat-form-field>

            </div>
            <div class="col-lg-3">
              <mat-form-field [style.width.%]="100">
                <mat-label for="invoice_date_range">Invoice Date Range</mat-label>
                <mat-date-range-input [rangePicker]="picker" [formGroup]="invoiceCreationDateRange"
                  id="invoice_date_range">
                  <input matStartDate formControlName="start_date" #startdate placeholder="Start Date" [max]="maxDate"
                    (dateChange)="onInvoiceCreationDateChanges()">
                  <input matEndDate formControlName="end_date" #endDate placeholder="End Date" [max]="maxDate"
                    (dateChange)="onInvoiceCreationDateChanges()">
                </mat-date-range-input>
                <button *ngIf="isDateRangeHasValue" mat-button matSuffix mat-icon-button
                  (click)="resetInvoiceCreationDateRange()">
                  <mat-icon>clear</mat-icon>
                </button>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>


            </div>

            <div class="row">
              <div class="col-lg-12 text-end">
                <button type="button" class="btncss me-2 btn_primary" (click)="getOpenSearchData();">
                  Search
                </button>
                <button type="button" class="btncss me-2 btn_secondary" (click)="ClearOpenSearch()">
                  Clear
                </button>
              </div>
            </div>



          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-lg-12">
          <app-basic-gridview *ngIf="lstURNData.length>0" class="setgrid" [lstData]="lstURNData"
            [gridTitle]="'Select URN'" [columnsToHide]="chnageTypeColumnsToHide" [showExcelDownloadOption]="true"
            [showSearchOption]="true" [showRecordsPerPageOption]="true" [hyperlinkCols]="['']" [style.width.%]="100"
            [showPagination]="true" (cellClickEvent)="cellClickEvent($event)"></app-basic-gridview>

        </div>
      </div>


      <div class="tab-content" *ngIf="isDataFound">

        <!-- Table View -->
        <div class="table_card_sec mb_0">
          <div class="table scroll_table">
            <!-- <div class="bx-sub-title">Filter Option</div> -->
            <div class="row">
              <div class="col-lg-3">
                <mat-form-field appearance="legacy" [style.width.%]="100">
                  <mat-label for="new_work_item">New Work Item Type
                    <span class="field-mandatory">*</span>
                  </mat-label>
                  <mat-select [(ngModel)]="selectedDocumentTypeTo"
                    (selectionChange)="onSelectDocumentTypeTo($event.value)" id="new_work_item">
                    <mat-option [value]="doc.value" *ngFor="let doc of docTypeListTo">
                      {{doc.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </div>
              <div class="col-lg-3" *ngIf="isSubDocumentExists">
                <mat-form-field appearance="legacy" [style.width.%]="100">
                  <mat-label for="category">Category
                    <span class="field-mandatory">*</span>
                  </mat-label>
                  <mat-select [(ngModel)]="selectedSubDocumentTypeTo" id="category">
                    <mat-option [value]="doc.value" *ngFor="let doc of subDocTypeListTo">
                      {{doc.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </div>
              <div class="col-lg-3">
                <span>Initial Queue : </span>
                <span>{{strProcessName}}</span>
              </div>


            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-6 cmnt_box_main">
                <div class="cmnt_textarea_sec" [ngClass]="isCommentExpand?'expanded_textarea':''">
                  <span class="textarea_font_sec" title="Show list of restricted keywords"
                    (click)="showModal(restrictedKeywordModal,'sm')">
                    <img src="../../../assets/img/transaction/info.png" alt="Info">
                  </span>
                  <span class="expand_textarea_sec" (click)="isCommentExpand = !isCommentExpand">
                    <img src="../../../assets/img/transaction/expand.png" alt="Expand" title="Expand">
                  </span>
                  <span class="textarea_editor_main_sec">
                    <span class="words_count_limit">
                      {{wordsTotal}}
                    </span>
                  </span>
                  <span class="comment_mandatory">*</span>
                  <textarea [(ngModel)]="strComments" required maxlength="1000"
                    (blur)="checkRestrictedKeywords(strComments)" class="cmnt_textarea"
                    (keyup)="function(strComments)"></textarea>
                  <!-- [class.invalid]="f.strComments.errors && (f.strComments.touched || submitted)" -->
                </div>
              </div>
              <div class="col-lg-3">
                <button type="button" class="btncss me-2 btn_primary" (click)="sumbitData();">
                  Submit
                </button>

              </div>

            </div>



          </div>
        </div>
      </div>





    </div>


  </div>
</div>
<ng-template #restrictedKeywordModal let-modal>
  <div class="modal-content">
    <div class="modal-header model_center_header">
      <h5 class="modal-title">Keyword Replacement Chart</h5>
      <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="model_close_btn">×</span>
      </button>
    </div>
    <div class="modal-body custom_modal_body">
      <div class="model_content">
        <div class="table_section">
          <div class="table-responsive tablecss mt10">
            <table class="table custom_table">
              <thead>
                <tr>
                  <th>Keywords</th>
                  <th>Auto Replacement</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of restrictedKeywords">
                  <td>{{ item.restrict }}</td>
                  <td>{{ item.replace }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>



<ng-template #invoiceSubmittedModal let-modal>
  <div class="modal-content">
    <div class="modal-header model_center_header">
      <h5 class="modal-title">Alert</h5>
      <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="model_close_btn">×</span>
      </button>
    </div>
    <div class="modal-body custom_modal_body">
      <div class="model_content">
        Some of the fields may be lost when you change the work item type.
        Are you sure you want to change the type?
      </div>
      <div class="model_center_btn_part">

        <button type="button" class="btncss me-2 btn_primary" (click)="modalReference.close();processInvoice();">
          Yes
        </button>

        <button type="button" class="btncss me-2 btn_secondary" (click)="modalReference.close()">
          No
        </button>
      </div>
    </div>
  </div>
</ng-template>